import React, { useEffect, useState, useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import DatePicker, { DateObject } from "react-multi-date-picker";
import DatePanel from "react-multi-date-picker/plugins/date_panel";
import { Link } from 'react-router-dom';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import Images from "assets/images/imageData";
import "../main.css";
import "./valetsalary.css";
import Layout from "components/sales/layout/layout";
import CardSection from "components/sales/cardSection/cardSection";
import DropDownInput from "components/sales/Input/dropDownInput/dropDownInput";
import ModalPop from 'components/sales/modal/modal';

const ValetSalary = ({ 
    getInfraIDForValet, 
    InfraIdList = {},
    markHolidaysForValet,
    valetHolidaysMark = {},
    match,
    history
}) => {
  const inputs = {
    pid: "",
    holidays: "",
  };
  const format = "YYYY-MM-DD";
  const [dates, setDates] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState(inputs);
  const [isModal, setIsModal] = useState(false);
  const [error, setError] = useState("");
  const { baseUrl } = useContext(BaseUrl);

  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getInfraIDForValet();
      setIsLoading(false);
    })();
  }, []);

  const handleSubmit = async () => {
    // Check if the required fields are filled
    if (!formData.pid || !dates.length) {
      setError(<h5>Please fill all required fields</h5>); // Set error message
      setIsModal(true); // Open the modal to show error
      return;
    }
  
    const payload = {
      project_id: formData.pid,
      holidays_dates: [dates]
    };
    
    
    setIsLoading(true);
    const res = await markHolidaysForValet(payload);
    setIsLoading(false);
    console.log("RES",res);
    if (res==true) {
      setIsModal(true); 
    } else {
      setError("Failed to mark holidays"); 
      // setIsModal(true); // Open the modal to show error
    }
  };
  
  console.log("OKOK",isModal);
  const handleModalHide = () => {
    setIsModal(false);
    setError(""); // Reset error state
    window.location.reload();
    // history.push(`${baseUrl}/valet-salary`);
  };

  return (
    <>
      <Layout title="Holiday View">
      <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css" />
        <CardSection title="Holiday View">
          <div className="row">
              <div className="col-md-6 mt-5">
                <DropDownInput
                  data={InfraIdList}
                  label={"PID List"}
                  required
                  errorMsg={"Required"}
                  getIdValue={(val) => {
                    setData({
                      ...formData,
                      pid: val.id,
                    });
                  }}
                  isStarRequired={true}
                />
              </div>
              <div className="col-md-6 mt-5">
              <div className="multiple-datepicker">
                {/* <i className="fa fa-calendar calendar-styling" ></i> */}
                <DatePicker
                    placeholder="DD-MM-YYYY"
                    label={"Paid Holidays"}
                    onChange={dates => { 
                        setDates(dates.join(",\n"))
                    }}
                    multiple
                    sort
                    format={format}
                    calendarPosition="bottom-center"
                    plugins={[<DatePanel />]}
                />
              </div>
              </div>
              <div className="col-md-3 mt-5 mb-4">
              <button
                disabled={false}
                type="submit"
                className="btn btn-primary"
                onClick={handleSubmit} 
              >
                {"Accept"}
              </button>
            </div>
            </div>
        </CardSection>
        <ModalPop
          title={(error) ? 'Error' : 'Success'}
          show={isModal}
          handleModalHide={handleModalHide}
        >
          {error ? (
            <div className="error-message">{error}</div>
          ) : (
            <div className="text-center">
              <div className="success">
                <img src={Images?.tick} alt="" />
              </div>
              <h5>{`Holidays for ${dates} Marked Successfully`}</h5>
            </div>
          )}
        <Button variant="secondary" onClick={handleModalHide}>
          OK
        </Button>
        </ModalPop>
      </Layout>
    </>
  );
};

export default ValetSalary;
